import { HeadingProps, Stack, StackProps } from '@chakra-ui/react'
import { LandingContainer } from 'components/common/LandingContainer'
import { H2 } from 'components/typography'
import { FC, ReactNode } from 'react'

export interface AboutSectionProps {
  title: string | ReactNode
  titleProps?: HeadingProps
  content: ReactNode[]
  contentContainerProps?: StackProps
}

export const AboutSection: FC<AboutSectionProps> = ({ title, titleProps, content, contentContainerProps }) => {
  return (
    <LandingContainer
      justify="center"
      direction={{
        base: 'column',
        lg: 'row'
      }}
      py={{
        base: '64px',
        lg: '96px'
      }}
      spacing={{
        base: 8,
        lg: 20
      }}
      maxW="880px"
    >
      <H2 minW="320px" maxW="420px" {...titleProps}>
        {title}
      </H2>

      <Stack spacing={4} {...contentContainerProps}>
        {content}
      </Stack>
    </LandingContainer>
  )
}
